var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTriangle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5796 7.72041L3.63955 36.0004C3.29029 36.6053 3.10549 37.291 3.10353 37.9894C3.10158 38.6879 3.28254 39.3747 3.62841 39.9815C3.97428 40.5883 4.473 41.0939 5.07497 41.4481C5.67693 41.8023 6.36115 41.9927 7.05955 42.0004H40.9396C41.638 41.9927 42.3222 41.8023 42.9241 41.4481C43.5261 41.0939 44.0248 40.5883 44.3707 39.9815C44.7166 39.3747 44.8975 38.6879 44.8956 37.9894C44.8936 37.291 44.7088 36.6053 44.3596 36.0004L27.4196 7.72041C27.063 7.13262 26.561 6.64665 25.9619 6.30938C25.3629 5.97211 24.687 5.79492 23.9996 5.79492C23.3121 5.79492 22.6362 5.97211 22.0372 6.30938C21.4381 6.64665 20.9361 7.13262 20.5796 7.72041V7.72041Z",
    stroke: "#EFAB39",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18V26",
    stroke: "#EFAB39",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34H24.02",
    stroke: "#EFAB39",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangle);
export default __webpack_public_path__ + "static/media/Icon-triangle.270e26faaf939dde090fbd61012f3b67.svg";
export { ForwardRef as ReactComponent };